import * as React from 'react';
import { FilterSearch, FilterToggle } from '../../../ui';
import { useInbox } from '../InboxContext';

const STATUS_OPTIONS = [
  { value: 'all',     label: 'All' },
  { value: 'unread',  label: 'Unread' },
  { value: 'starred', label: 'Flagged' },
];

function EmailListHeader({ search, setSearch, statusFilter, setStatusFilter }) {
  const { activeFolder, folderEmails, selectedIds, selectAll, clearSelection, actions } = useInbox();

  const allChecked = selectedIds.size > 0 && selectedIds.size === folderEmails.length;
  const someChecked = selectedIds.size > 0;

  const isTrashOrArchive = activeFolder === 'trash' || activeFolder === 'archive';

  const handleSelectAll = () => {
    if (allChecked) clearSelection();
    else selectAll(folderEmails.map((e) => e.id));
  };

  const bulkBtn = 'px-1.5 py-0.5 rounded bg-surface hover:bg-surface-warm transition-colors';

  return (
    <div className="flex flex-col gap-1">
      {/* Row 1: Search — full width */}
      <FilterSearch
        value={search}
        onChange={setSearch}
        placeholder="Search… (use + for multi-filter)"
        size="sm"
        width="full"
      />

      {/* Row 2: Select-all checkbox + filter toggle */}
      <div className="flex items-center gap-1.5">
        <input
          type="checkbox"
          checked={allChecked}
          ref={(el) => { if (el) el.indeterminate = someChecked && !allChecked; }}
          onChange={handleSelectAll}
          className="h-3 w-3 rounded border-nn-border accent-aqua cursor-pointer shrink-0"
        />
        <FilterToggle
          value={statusFilter}
          onChange={setStatusFilter}
          options={STATUS_OPTIONS}
        />
      </div>

      {/* Bulk action bar — context-aware */}
      {someChecked && (
        <div className="flex items-center gap-1.5 text-[10px] text-text-muted pt-0.5">
          <span className="font-semibold">{selectedIds.size} selected</span>
          <button type="button" onClick={() => actions.bulkMarkRead([...selectedIds])} className={bulkBtn}>Mark Read</button>
          <button type="button" onClick={() => actions.bulkMarkUnread([...selectedIds])} className={bulkBtn}>Mark Unread</button>
          {isTrashOrArchive ? (
            <button type="button" onClick={() => { actions.bulkMoveToInbox([...selectedIds]); clearSelection(); }}
              className="px-1.5 py-0.5 rounded bg-aqua-glow/10 text-aqua hover:bg-aqua/10 transition-colors font-semibold">
              Move to Inbox
            </button>
          ) : (
            <>
              <button type="button" onClick={() => { actions.bulkArchive([...selectedIds]); clearSelection(); }} className={bulkBtn}>Archive</button>
              <button type="button" onClick={() => { actions.bulkTrash([...selectedIds]); clearSelection(); }}
                className="px-1.5 py-0.5 rounded bg-red-bg text-red-critical hover:bg-red-critical/10 transition-colors">Delete</button>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export { EmailListHeader };
